const Thanks = () => (
  <div className="container-fluid px-0 graciasbg">
    <div className="container">
      <div className="row pt-4 d-flex justify-content-center" id="gracias">
        <div className="col-xl-6 col-lg-6 col-md-8 col-sm-10 col-10 col">
          <h3 className="text-center">¡Muchas Gracias por participar!</h3>
		  <p>En los próximos días recibirás por mail los resultados de este primer juego.</p>
        </div>
      </div>
    </div>
  </div>
);
export default Thanks;
